$(function() {
    // if ( $('#player').length ) {
    //     var player = videojs('my-video');
    //     var videoContainer = document.querySelector('.video-container');
    // }

    // // Function to check if an element is in the viewport
    // function isElementInViewport(el) {
    //     var rect = el.getBoundingClientRect();
    //     return (
    //         rect.top >= 0 &&
    //         rect.left >= 0 &&
    //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    //     );
    // }
    // function handleVideoIntersection(entries, observerVideo) {
    //     entries.forEach(entry => {
    //       if (entry.isIntersecting) {
    //         // Video is in view, play it
    //         player.play();
    //         // observer.disconnect(); // Stop observing once played
    //       } else {
    //         // Video is not in view, pause it
    //         player.pause();
    //       }
    //     });
    // }
    // Function to play video when it enters the viewport
    function handleVideoPlayback(player) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        player.play(); // Play video when it enters the viewport
                    } else {
                        player.pause(); // Pause video when it leaves the viewport
                    }
                });
            },
            {
                threshold: 0.5, // Trigger when at least 50% of the video is visible
            }
        );

        // Observe the player's container
        observer.observe(player.elements.container);
    }

    // // Update cursor class based on video state
    // function updateCursor() {
    //     if (player.paused()) {
    //       videoContainer.classList.remove('playing');
    //     } else {
    //       videoContainer.classList.add('playing');
    //     }
    // }

    // if ( player ) {
    //     // Create an intersection observer
    //     var observerVideo = new IntersectionObserver(handleVideoIntersection);
    
    //     // Observe the video element
    //     observerVideo.observe(player.el());
    
    //     // You may want to customize the threshold and other options based on your requirements
    //     // Set initial cursor class based on video state
    //     updateCursor();

    //     // Update cursor on play/pause events
    //     player.on('play', updateCursor);
    //     player.on('pause', updateCursor);

    //     // You may want to customize the cursor image URLs and other options based on your requirements
    // }
    

    function addCursorControl(player) {
      // Set initial cursor state based on the player's status
      if (player.playing) {
          player.elements.container.classList.add('pause-cursor');
      } else {
          player.elements.container.classList.add('play-cursor');
      }
  
      // Add play event to switch to pause cursor
      player.on('play', () => {
          player.elements.container.classList.remove('play-cursor');
          player.elements.container.classList.add('pause-cursor');
      });
  
      // Add pause event to switch to play cursor
      player.on('pause', () => {
          player.elements.container.classList.remove('pause-cursor');
          player.elements.container.classList.add('play-cursor');
      });
  
      // Reset to play cursor when video ends
      player.on('ended', () => {
          player.elements.container.classList.remove('pause-cursor');
          player.elements.container.classList.add('play-cursor');
      });
  }

    const players = Array.from(document.querySelectorAll('.plyr')).map((p) => {
        const player = new Plyr(p);
        addCursorControl(player); // Apply cursor control to each player
        return player;
    });

    const defaultPlayers = Array.from(document.querySelectorAll('.plyr-default')).map((p) => {
        const defaultPlayer = new Plyr(p);
        addCursorControl(defaultPlayer); // Apply cursor control to each player
        handleVideoPlayback(defaultPlayer); // Add IntersectionObserver functionality
        return defaultPlayer;
    });
    
    const playersSlider = Array.from(document.querySelectorAll('.plyr-slide')).map((p) => {
      const playerSlide = new Plyr(p,{
        controls: [],           // Remove all controls
            youtube: {
                controls: 0,        // Hide YouTube's native controls
                rel: 0,             // Disable related videos at the end
                showinfo: 0,        // Hide video title and uploader info
            },
      });
      addCursorControl(playerSlide); // Apply cursor control to each player
      return playerSlide;
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/video.js